import { SettingActions } from "../../../../../components/SettingHeader/settingActions";

export const Support = () => {
  return <SettingActions />;
};
